import { ModuleFeatureEnum } from '../../enums/module-feature.enum';
import { PortalSettingEnum } from '../../enums/portal-setting-type.enum';
import { UserRole } from '../auth/userRole';

export class PortalSetting {
  public id: number;
  public businessUnitId: number;
  public type: PortalSettingEnum;
  public message: string;
  public userRole: UserRole;
  public moduleFeature: ModuleFeatureEnum;
}
